import { camelCase, upperFirst } from 'lodash-es';

export const pascalCase = (str: string) => {
  return upperFirst(camelCase(str));
};
